import React from "react";
import _ from "lodash";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles, createMuiTheme } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import { InputLabel } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";

const useStyles = makeStyles({
  autoComplete: {
    color: "red",
  },
});

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: "100%",
        marginBottom: "12px",
      },
    },
    MuiInput: {
      formControl: {
        marginTop: "0 !important",
      },
    },
    MuiOutlinedInput: {
      root: {
        paddingRight: "0 !important",

        "& $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "&:hover $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
      },
      input: {
        borderRadius: "6px",
        backgroundColor: "rgba(2, 72, 157, 0.14) !important",
        color: "#fff",
        padding: "14px 0",
        fontSize: "16px",
        lineHeight: "19px",
      },
    },
    MuiIconButton: {
      root: {
        color: "#fff",
      },
    },
    MuiInputLabel: {
      root: {
        textTransform: "uppercase",
        fontFamily: "Lato",
        fontSize: "14px",
        lineHeight: "17px",
        padding: "0",
        color: "rgba(255, 255, 255, 0.5)",
        marginBottom: "10px",
      },
      formControl: {
        position: "inherit",
        transform: "none",
        marginBottom: "12px",
      },
    },
  },
});

const TimePicker = ({ timeOnsite, setTimeOnsite, label }: any) => {
  const classes = useStyles();
  const dateUtils = new DateFnsUtils();

  return (
    <ThemeProvider theme={theme}>
      {label && <InputLabel variant="standard">{label}</InputLabel>}
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardTimePicker
          placeholder="16:00"
          ampm={false}
          inputVariant="outlined"
          invalidDateMessage="Invalid Time"
          value={timeOnsite}
          mask="__:__"
          InputAdornmentProps={{
            style: { display: "none" },
          }}
          inputProps={{ style: { textAlign: "center", borderColor: "#ECECEC" } }}
          onChange={(date, value: any) => {
            setTimeOnsite(date);
          }}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

export default TimePicker;
